import {
  UPDATE_ZOOM_COURSE_DATA,
  UPDATE_ZOOM_COURSE_TYPE,
  ZOOM_COURSE_UPLOAD_REQUEST,
  ZOOM_COURSE_UPLOAD_SUCCESS
} from '../constants/action-types'

const defaultState = {
  isSingleCourse: true,
  courseId: '',
  courseIds: [],
  requestedBy: '',
  uploadS3DataLoading: false,
  uploadS3DataSet: {},
  uploadedDataResult: {},
  daysCount: ''
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_ZOOM_COURSE_DATA: {
      return {
        ...state,

        courseId: action.payload.courseId,
        courseIds: action.payload.courseIds,
        requestedBy: action.payload.requestedBy,
        daysCount: action.payload.daysCount
      }
    }

    case UPDATE_ZOOM_COURSE_TYPE: {
      return {
        ...state,
        isSingleCourse: action.payload
      }
    }

    case ZOOM_COURSE_UPLOAD_REQUEST: {
      return {
        ...state,
        uploadS3DataLoading: action.payload
      }
    }

    case ZOOM_COURSE_UPLOAD_SUCCESS: {
      return {
        ...state,
        uploadS3DataLoading: false,
        uploadedDataResult: action.payload
      }
    }

    default:
      return state
  }
}
